// Lo que hace GUIA (spec v4, specs/home-conversacional/ESPECIFICACION.md, 03/11/2026).
// Decidido por An tras la reunión con Ricardo Curtino del 03/11. Son las opciones de la primera
// pantalla: cada una abre su recorrido en flows.js (Recorridos v4) y termina en su oferta
// (ofertas.js). En la web no se nombra «Claude» (An, 04/11: la Agencia funciona sobre Claude pero se presenta
// como Agencia, Agentes o Tareas; «nosotros sabemos que es claude») y se dice «tareas» (An, 04/11: «en vez de habilidades tareas»; el id sigue
// siendo 'habilidades' para no cortar la medición). Las líneas son de An (04/11): Agencia la dirección (05/11; antes «el cerebro»), Agentes la estructura, Tareas la capacidad. Sin apps (18/10).
// 🔴 Los niveles van SIEMPRE en mayúsculas (An, 03/11): nunca mezclar mayúsculas y minúsculas.

// Dos grupos (An, 04/11: «REESTRUCTUREMOS EL CONTENIDO»): los productos de IA y los servicios. «Para personas»
// dejó de ser un grupo aparte.
// Cada producto entra directo a su página (An, 05/11: «si alguien entra a Agencia no sabe qué es: no está bueno
// decirle de una para qué lo querés»). Sus preguntas (`preguntas`, nodos de flows.js) las contesta quien ya leyó y
// se postula, en el chat del contacto; se saltea la que ya está contestada. Para quién es lo dice un solo switch arriba
// de los productos, «Soy: Empresa / Persona» (An, 05/11: «queda espantoso repetir los botones»), porque cambia lo
// que dice la página. `personal`: lo que además deja puesto «Persona» en ese producto (en Agencia, el equipo
// «Solo yo», que sugiere INICIAL).
export const GRUPOS = [
  // La bajada dice que son piezas (An, 04/11: «son 3 productos, todo puede estar junto o los podés comprar
  // por separado, es modular, tipo lego»). 🟠 Texto mío, a validar por An.
  { id: 'ia', titulo: 'Productos de IA', bajada: 'Se contratan por separado o en conjunto.' },
  { id: 'servicio', titulo: 'Nuestros servicios' },
];

// El switch de la home (ConversationalExperience): deja `para` puesto en lo recolectado.
export const SOY = [
  { id: 'empresa', label: 'Empresa' },
  { id: 'personal', label: 'Persona' },
];

// Agencia es el nombre del producto que antes se llamaba «IA que hace tareas» (An, 03/11 lo llamó GENIA; 04/11:
// «en vez de genia pone agencia»). Cada cliente tiene una agencia con agentes por área que tienen tareas.
// Qué es lo dice la bajada de la apertura.
export const PRODUCTOS = [
  { id: 'ia', grupo: 'ia', nombre: 'Agencia', linea: 'La Dirección', next: 'ia_result', preguntas: ['ia_equipo', 'ia_tarea'],
    personal: { equipo: 'Solo yo' } },
  { id: 'habilidades', grupo: 'ia', nombre: 'Tareas', linea: 'La capacidad', next: 'hab_result', preguntas: ['hab_q1'] },
  { id: 'agentes', grupo: 'ia', nombre: 'Agentes', linea: 'La estructura', next: 'agentes_result', preguntas: ['agentes_q1'] },
  // Scan es para empresas: con «Persona» no se muestra (`soloEmpresa`; An, 05/11: «que se oculte»), y la línea no repite lo que ya dice el switch.
  { id: 'scan', grupo: 'ia', nombre: 'Scan', linea: 'Chequeo digital', next: 'sistema_result', preguntas: ['sistema_q1'], soloEmpresa: true },
  { id: 'capacitaciones', grupo: 'servicio', nombre: 'Capacitaciones IA', linea: 'Aprendé haciendo', next: 'taller_result' },
  { id: 'consultoria', grupo: 'servicio', nombre: 'Consultoría tech', linea: 'Pensamos con vos', next: 'consultoria_result' },
];

export const IDS_PRODUCTO = PRODUCTOS.map(p => p.id);

export const PROMESA = {
  // El rótulo sigue al switch, que así muestra que cambió algo (Nielsen, visibilidad del estado del sistema).
  rotulo: { empresa: 'Asesoría de IA · Equipos y empresas · Córdoba', personal: 'Asesoría de IA · Personas · Córdoba' },
  // Apertura (An, 03/11): titular y bajada de An. Concreta como las frases de la reunión con Ricardo («es un sistema que consulta
  // tu ERP»: dice qué es y qué toca), y el alivio debajo, con el dolor implícito (mapa de dolor de las
  // reseñas: «corriendo todo el día», «mucha ocupación sin avanzar en lo que importa»). La bajada es de An.
  titular: 'Ejecutá hablando.', // An, 03/11
  bajada: 'IA que ya sabe qué hacer, vos decís cuándo.', // An, 04/11 (antes «IA al servicio de tus tareas.»)
};
